import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let routes = [
  {
    path: '/login',
    component: re => require(['../components/main/common/Login.vue'], re)
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    meta: 'start',
    path: '/',
    component: re => require(['../components/main/common/Home.vue'], re),
    children: [
      {
        meta: 'Music ',
        icon: 'el-icon-service',
        path: '/music-list',
        defaultPath: true,
        component: re => require(['../components/music/MusicList.vue'], re)
      },
      {
        meta: 'Audio ',
        icon: 'el-icon-mic',
        path: '/audiotext-list',
        defaultPath: true,
        component: re => require(['../components/audioText/AudioTextList.vue'], re)
      },
      {
        meta: 'Exercise ',
        icon: 'el-icon-chicken',
        path: '/exercise-list',
        defaultPath: true,
        component: re => require(['../components/exercise/ExerciseList.vue'], re)
      },
      {
        meta: 'Exercise add/change',
        icon: 'el-icon-coin',
        path: '/exercise-editor',
        component: re => require(['../components/exercise/ExerciseEditor.vue'], re),
        noShow: true,
      },
      {
        meta: 'Workout ',
        icon: 'el-icon-dish ',
        path: '/workout-list',
        defaultPath: true,
        component: re => require(['../components/workout/WorkoutList.vue'], re)
      },
      {
        meta: 'Target Areas',
        icon: 'el-icon-box',
        path: '/library-list',
        defaultPath: true,
        component: re => require(['../components/library/LibraryList.vue'], re),
      },
      {
        meta: 'Collection',
        icon: 'el-icon-collection',
        path: '/collection-list',
        defaultPath: true,
        component: re => require(['../components/collection/CollectionList.vue'], re),
      },
      {
        meta: 'Workout add/change',
        icon: 'el-icon-coin',
        path: '/workout-editor',
        component: re => require(['../components/workout/WorkoutEditor.vue'], re),
        noShow: true,
      },
      {
        meta: 'Music add/change',
        icon: 'el-icon-coin',
        path: '/music-editor',
        component: re => require(['../components/music/MusicEditor.vue'], re),
        noShow: true,
      },
      {
        meta: 'AudioText add/change',
        icon: 'el-icon-coin',
        path: '/audiotext-editor',
        component: re => require(['../components/audioText/AudioTextEditor.vue'], re),
        noShow: true,
      },
      {
        meta: 'Your Personal',
        icon: 'el-icon-medal',
        path: '/your-personal',
        component: re => require(['../components/YourPersonal.vue'], re)
      },
      {
        meta: 'Collection add/change',
        icon: 'el-icon-coin',
        path: '/collection-editor',
        component: re => require(['../components/collection/CollectionEditor.vue'], re),
        noShow: true,
      },
      {
        meta: 'Library add/change',
        icon: 'el-icon-coin',
        path: '/library-editor',
        component: re => require(['../components/library/LibraryEditor.vue'], re),
        noShow: true,
      },
      {
        meta: 'Library select workout',
        icon: 'el-icon-coin',
        path: '/library-select-workout',
        component: re => require(['../components/library/LibrarySelectWorkout.vue'], re),
        noShow: true,
      },
      {
        meta: 'Auto Plan',
        icon: 'el-icon-magic-stick',
        path: '/autoPlan-list',
        defaultPath: true,
        component: re => require(['../components/autoPlan/AutoPlanList.vue'], re),
      },
      {
        meta: 'Auto Plan add/change',
        icon: 'el-icon-coin',
        path: '/autoPlan-editor',
        component: re => require(['../components/autoPlan/AutoPlanEditor.vue'], re),
        noShow: true,
      },
      // {
      //     meta: 'You might like',
      //     icon: 'el-icon-medal',
      //     path: '/may-like',
      //     component: re => require(['../components/MayLike.vue'], re)
      // },
      {
        meta: 'Text ',
        icon: 'el-icon-notebook-2',
        path: '/yoga',
        component: re => require(['../components/Yoga.vue'], re)
      },
      {
        meta: 'Article',
        icon: 'el-icon-reading ',
        path: '/article-list',
        defaultPath: true,
        component: re => require(['../components/article/ArticleList.vue'], re)
      },
      {
        meta: 'Article add/change',
        icon: 'el-icon-coin',
        path: '/article-editor',
        component: re => require(['../components/article/ArticleEditor.vue'], re),
        noShow: true,
      },
      {
        meta: 'Reminder',
        icon: 'el-icon-news ',
        path: '/reminder-list',
        defaultPath: true,
        component: re => require(['../components/reminder/ReminderList.vue'], re)
      },
      {
        meta: 'Reminder add/change',
        icon: 'el-icon-coin',
        path: '/reminder-editor',
        component: re => require(['../components/reminder/ReminderEditor.vue'], re),
        noShow: true,
      },
      {
        meta: 'Daily Image',
        icon: 'el-icon-picture-outline ',
        path: '/dailyimage-list',
        defaultPath: true,
        component: re => require(['../components/daliyImage/DailyImageList.vue'], re)
      },
      {
        meta: 'DailyImage add/change',
        icon: 'el-icon-coin',
        path: '/dailyimage-editor',
        component: re => require(['../components/daliyImage/DaliyImageEditor.vue'], re),
        noShow: true,
      },
    ]
  }
]
// router做空组件注入
routes.some(item => {
  if (item.meta === 'start') {
    item.children.some(item2 => {
      if (!item2.component) {
        item2.component = { render: e => e('router-view') }
      }
    })
  }
})
export default new Router({
  routes
})